import {DashboardLink} from '@hconnect/common/components/downtime'
import {EquipmentRunningTimesDto as EquipmentRunningTimes} from '@hconnect/common/types'
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap'
import {Button, Grid, Theme, useMediaQuery} from '@mui/material'
import {isEmpty} from 'lodash'
import {FC} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'

import {EquipmentSelector} from './EquipmentSelector'
import {GraphLegend} from './GraphLegend'

type StoppageAnalysisGraphActionsProps = {
  plantId: string
  equipmentId: string
  onEquipmentChange: (id: string) => void
  data: EquipmentRunningTimes[]
  onZoomReset: (id?: string) => void
  equipmentIdToPreview?: string
  disableEquipmentChange?: boolean
  disableResetZoom?: boolean
}

export const StoppageAnalysisGraphActions: FC<StoppageAnalysisGraphActionsProps> = ({
  plantId,
  equipmentId,
  onEquipmentChange,
  equipmentIdToPreview,
  onZoomReset,
  data,
  disableEquipmentChange,
  disableResetZoom
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))
  const equipmentWithRunningTimes = data.find((eq) => eq.equipment?.id === equipmentId)

  return (
    <>
      <Grid item sm={2} md={2}>
        <EquipmentSelector
          data={data}
          onChange={onEquipmentChange}
          value={equipmentIdToPreview}
          disabled={disableEquipmentChange}
        />
      </Grid>
      <Grid item sm={2} md={2} display="flex" alignItems="center">
        <GraphLegend
          totalStopped={equipmentWithRunningTimes?.totalStopped}
          totalRunning={equipmentWithRunningTimes?.totalRunning}
          showOperationHoursLegend={!isEmpty(equipmentWithRunningTimes)}
        />
      </Grid>
      <Grid item sm={8} md={8} textAlign="right">
        {!isMobile && (
          <Button
            variant="text"
            startIcon={<ZoomOutMapIcon />}
            onClick={() => onZoomReset()}
            sx={{mr: 1}}
            disabled={disableResetZoom}
            data-test-id="stoppage-analysis-reset-zoom"
          >
            {t('stoppageAnalysisGraph.action.resetZoom')}
          </Button>
        )}
        {/* TODO: find out if we can remove the link as it is redundant with navigation menus */}
        <DashboardLink plantId={plantId} title={t('label.goToDowntimeDashboard')} />
      </Grid>
    </>
  )
}
